import * as menuRouter from './';

const clubRouter = Object.keys(menuRouter).reduce((acc, cur) => {
    return [...acc, ...menuRouter[cur]];
}, []);

const routerMap = [...clubRouter];

export default routerMap;
